module.exports = __webpack_public_path__ + "assets/media/dots__store.e8020bd2.svg";